<template>
  <div>
    <div class="page-container">
      <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item>blockInfo</el-breadcrumb-item>
    </el-breadcrumb> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <span class="page-title">财务报表</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>余额账单</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card class="page-content" shadow="never">
        <div class="page-actions">
          <el-input v-model="val1" placeholder="请输入用户Id" clearable></el-input>
          <el-select v-model="coin" placeholder="请筛选币种" clearable>
            <el-option
              v-for="item in allCoins"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <!-- <el-select v-model="type" placeholder="请筛选订单类型" clearable>
            <el-option
              v-for="item in allCoins"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select> -->
         
          <el-button type="primary" @click="handleSearch" >搜索</el-button>
          <a  @click="getExcel" target="_blank" >导出Excel</a>
        </div>
        <user-list @refresh="refreshList"></user-list>
      </el-card>
    </div>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState } from "vuex";
import UserList from "./components/list";
export default {
  components: {
    UserList,
  },
  data() {
    return {
        val1:'',
       coin:'',
       type:'',
        value2:'',
        page:1,size:25,
      
    };
  },
  computed: {
    ...mapState('financeBalance',['allCoins'])
  },
  methods: {
    ...mapActions('financeBalance',['getOrderList','exportExcel','getFbsPairs','getAllCoins']),
    refreshList(data={}){
        this.page=data.page
        this.size=data.size
        this.getOrderList({
        coin:this.coin,
        page:this.page,size:this.size,
        userId:this.val1,
        ...data
    })
    },
    handleSearch(){
        this.getOrderList({
        coin:this.coin,
        type:this.type,
        page:1,size:this.size,
        userId:this.val1
    })
    },
    getExcel(){
        this.exportExcel({
            coin:this.coin,
            userId:this.val1
        }).then(res=>{
        
            const link=document.createElement('a') 
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
            link.style.display = 'none'
            // 设置连接
            link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
            console.log('link-href',link.href);
            link.download = '现货订单统计报表'
            document.body.appendChild(link)
            // 模拟点击事件
            link.click()  //设置点击事件
         
       

      }).catch(error=>{
        this.$message.error(error)
      });
    }
  },
  created() {
    this.getOrderList({
        coin:this.coin,
        page:this.page,size:this.size,
        userId:this.val1
    })
    // this.getFbsPairs()
    this.getAllCoins()
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 10px;
}
</style>
